import {
    GET_CAMPAIGN_COMPLETED,
    GET_CAMPAIGN_COMPLETED_DATA,
    GET_CAMPAIGN_COMPLETED_END,
    GET_CAMPAIGN_COMPLETED_START,
    GET_CAMPAIGN_COMPLETED_WINNER,
    GET_CAMPAIGN_COMPLETED_WINNER_TRANSACTIONS,
    GET_CAMPAIGN_COMPLETED_HISTORY_TRANSACTIONS,
    GET_CAMPAIGN_WITH_STATUS,
    GET_CAMPAIGN_BY_ID,
    GET_EXECUTED_WINNERS,
    BLACKLIST_CREATE,
    BLACKLIST_DELETE
} from '../slices/type'

interface InitState {
    data: any[];
    data2: any[];
    dataWithStatus: any[];
    winner: any[];
    winnerTransactions: any[];
    historyTransactions: any[];
    dataSingle: any[];
    campaignById: any | null;
    executedWinners: any[];
    loading: boolean;
}

const initState: InitState = {
    data: [],
    data2: [],
    dataWithStatus: [],
    winner: [],
    winnerTransactions: [],
    historyTransactions: [],
    dataSingle: [],
    campaignById: null,
    executedWinners: [],
    loading: false,
};

interface Action {
    type: string;
    payload?: any;
    loading?: boolean;
}

const getCompletedCampaign_Red = (state = initState, action: Action): InitState => {
    switch (action.type) {
        case GET_CAMPAIGN_COMPLETED_START:
            return {
                ...state,
                loading: action.loading ?? false,
            };
        case GET_CAMPAIGN_COMPLETED_DATA:
            return {
                ...state,
                data: action.payload ?? [],
                loading: action.loading ?? false,
            };
        case GET_CAMPAIGN_COMPLETED:
            return {
                ...state,
                data2: action.payload ?? [],
                loading: action.loading ?? false,
            };
        case GET_CAMPAIGN_COMPLETED_WINNER:
            return {
                ...state,
                winner: action.payload ?? [],
                loading: action.loading ?? false,
            };
        case GET_CAMPAIGN_COMPLETED_WINNER_TRANSACTIONS:
            return {
                ...state,
                winnerTransactions: action.payload ?? [],
                loading: action.loading ?? false,
            };
        case GET_CAMPAIGN_COMPLETED_HISTORY_TRANSACTIONS:
            return {
                ...state,
                historyTransactions: action.payload ?? [],
                loading: action.loading ?? false,
            };
        case GET_CAMPAIGN_WITH_STATUS:
            return {
                ...state,
                dataWithStatus: action.payload ?? [],
                loading: action.loading ?? false,
            };
        case GET_CAMPAIGN_BY_ID:
            return {
                ...state,
                campaignById: action.payload ?? null,
                loading: action.loading ?? false,
            };
        case GET_EXECUTED_WINNERS:
            return {
                ...state,
                winner: action.payload ?? [],
                loading: action.loading ?? false,
            };
        case BLACKLIST_CREATE:
        case BLACKLIST_DELETE:
            return { ...state, loading: false };
        case GET_CAMPAIGN_COMPLETED_END:
            return {
                ...state,
                dataSingle: action.payload ?? [],
                loading: action.loading ?? false,
            };
        default:
            return state;
    }
};

export default getCompletedCampaign_Red;
